import { matchPath } from "react-router-dom";
import { PageRoute, pages as pagesConfig } from "src/components/routes";
import { UserRole } from "src/constants/roles";
import { PAGES } from "src/types/navigation";

type Route = PageRoute;
type RouteWithScheme = Route & { scheme: PAGES };

export const prepareURL = (pathname: string): PAGES | undefined => {
  const path = pathname.split("/~")[0] as PAGES;
  const pages = Object.values(PAGES).filter((item) => item !== "*");
  
  if (pages.includes(path as any)) {
    return path;
  }

  const match = pages
    .map((scheme) => matchPath(path, scheme))
    .find((item) => item);

  return match?.pathname as PAGES | undefined;
};

const allRoutes = (config: Record<string, Route>): RouteWithScheme[] =>
  Object.keys(config).map(
    (scheme: string) => ({ scheme, ...config[scheme] } as RouteWithScheme)
  );

// ПРОСТАЯ проверка доступа
export const hasAccessToPage = (
  scheme: PAGES,
  userRole: UserRole | null
): boolean => {
  const pageConfig = pagesConfig[scheme];
  if (!pageConfig) return false;
  
  // Публичные страницы доступны всем
  if (pageConfig.access.length === 0) return true;
  
  // Если нет роли - нет доступа к приватным страницам
  if (!userRole) return false;
  
  // Проверяем, есть ли роль в списке доступов
  return pageConfig.access.includes(userRole);
};

export const allPages: PAGES[] = allRoutes(pagesConfig).map(
  (item) => item.scheme as PAGES
);

export const getRouteConfigByPath = (path?: string): Partial<PageRoute> =>
  pagesConfig[path as PAGES] || {};